import React from 'react'

const withSessionLogic = WrappedComponent => {
  return props => {
    const { sessions, ...rest } = props

    // Pass all sessions that have financial aid configured
    // Let each component handle its own date filtering logic
    const sessionsWithFinancialAid = sessions?.filter(s => s.financialAidOpenAt) || []

    return (
      <WrappedComponent
        sessions={sessionsWithFinancialAid}
        {...rest}
      />
    )
  }
}

export default withSessionLogic

